import { createSelector } from '@reduxjs/toolkit';
import { EPriceType } from '../../../../packages/JsonQuery';
import { selectPriceTypeValue } from './selectPriceTypeValue';

const PRICE_TYPES_NAMES: Record<EPriceType, string> = {
  [EPriceType.Total]: 'за всё',
  [EPriceType.SM]: 'за м\u00B2',
};

export const selectPriceTypeLabel = createSelector(selectPriceTypeValue, priceType => PRICE_TYPES_NAMES[priceType]);
